import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Sparkles, Zap, Layers, Cpu, Code2, Rocket } from 'lucide-react';

export default function ProductSynthesis() {
  return (
    <SubpageTemplate 
      title="Synthesis Engine"
      subtitle="The heart of Yacht Labs"
      description="Our proprietary AI core that transforms fuzzy ideas into production-ready project architectures. Not just a code generator, but a technical architect in a box."
      icon={Sparkles}
      features={[
        {
          title: "Neural Architecture",
          description: "Synthesizes complete folder structures, component hierarchies, and data schemas from natural language.",
          icon: Cpu
        },
        {
          title: "Context Injection",
          description: "Maintains absolute state awareness across yours builds. No hallucinated imports or detached components.",
          icon: Layers
        },
        {
          title: "Zero-Knowledge Logic",
          description: "Highly secure inference processes that ensure your proprietary business logic stays yours.",
          icon: Zap
        }
      ]}
    />
  );
}
